import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcInputComponent } from './fc-input.component';

const components = [FcInputComponent];
@NgModule({
    imports: [CommonModule],
    declarations: components,
    exports: components
})
export class FcInputModule {}
